import { render, staticRenderFns } from "./price-change.vue?vue&type=template&id=1f8ed28c&scoped=true"
import script from "./price-change.vue?vue&type=script&lang=js"
export * from "./price-change.vue?vue&type=script&lang=js"
import style0 from "./price-change.vue?vue&type=style&index=0&id=1f8ed28c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ed28c",
  null
  
)

export default component.exports